import { render, staticRenderFns } from "./sidebar-right.vue?vue&type=template&id=13367d5d&scoped=true&"
import script from "./sidebar-right.vue?vue&type=script&lang=js&"
export * from "./sidebar-right.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-right.vue?vue&type=style&index=0&id=13367d5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13367d5d",
  null
  
)

export default component.exports